/* Extracted from wedding-page-mockup/index.html. Keep parity changes in the canonical prototype first. */
(() => {
  // Kept inside each standalone runtime so the live theme needs no new dependency.
  const createFieldValidation = (form, { signal, requiredNames = [] } = {}) => {
    const errors = new Map();
    const prefix = `AvanaFieldError-${window.crypto?.randomUUID?.() || Math.random().toString(36).slice(2)}`;
    let sequence = 0;
    const eligible = (field) => field?.matches?.('input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"]), select, textarea');
    const messageFor = (field) => {
      if (!eligible(field) || field.disabled) return '';
      const value = field.value.trim();
      const name = field.name;
      const required = field.required || requiredNames.includes(name);
      const dateDisplay = field.matches('[data-lead-date-display]');
      if (dateDisplay && form.querySelector('[name="date_flexible"]')?.checked) return '';
      if (/^(estimate_)?(first_name|last_name)$/.test(name) && (required || value) && Array.from(value).length < 2) return 'Please enter at least 2 characters.';
      if (!value && !required) return '';
      if (field.type === 'email') return !value || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) ? 'Please enter a valid email address.' : '';
      if (field.type === 'tel') {
        let digits = value.replace(/\D/g, '');
        if (digits.length === 11 && digits.startsWith('1')) digits = digits.slice(1);
        return digits.length === 10 ? '' : 'Please enter a valid 10-digit phone number.';
      }
      if (name === 'event_type' && !value) return 'Please choose your event type.';
      if (name === 'guest_count' && !value) return 'Please choose your estimated guest count.';
      if (dateDisplay) {
        const label = (field.getAttribute('aria-label') || 'event date').replace(/\*$/, '').toLowerCase();
        return value && form.querySelector('[data-lead-date]')?.value ? '' : `Please add your ${label}.`;
      }
      if (/^(estimator|drawer)_guests$/.test(name)) return value && Number(value) >= 1 && Number(value) <= 340 && field.checkValidity() ? '' : 'Please enter a guest count between 1 and 340.';
      if (/^(estimator|drawer)_date$/.test(name)) return value && field.checkValidity() && (!field.min || value >= field.min) && (!field.max || value <= field.max) ? '' : field.type === 'month' ? 'Please choose a valid month and year.' : 'Please choose a valid event date.';
      if (!value) return name === 'message' ? 'Please add your message.' : 'Please complete this field.';
      return field.checkValidity() ? '' : 'Please check this value.';
    };
    const clearError = (field) => {
      const error = errors.get(field);
      if (!error) return;
      const describedBy = (field.getAttribute('aria-describedby') || '').split(/\s+/).filter((id) => id && id !== error.id);
      if (describedBy.length) field.setAttribute('aria-describedby', describedBy.join(' '));
      else field.removeAttribute('aria-describedby');
      field.removeAttribute('aria-invalid');
      field.removeAttribute('aria-errormessage');
      error.remove();
      errors.delete(field);
      const summary = form.querySelector('.form-error[data-validation-summary]');
      if (!errors.size && summary) { summary.hidden = true; delete summary.dataset.validationSummary; }
    };
    const setError = (field, message) => {
      if (!message) { clearError(field); return; }
      let error = errors.get(field);
      if (!error) {
        error = document.createElement('span');
        error.className = 'avana-field-error';
        error.id = `${prefix}-${++sequence}`;
        const icon = document.createElement('span');
        icon.className = 'avana-field-error-icon';
        icon.setAttribute('aria-hidden', 'true');
        icon.textContent = '!';
        const text = document.createElement('span');
        text.className = 'avana-field-error-text';
        error.append(icon, text);
        const dateContainer = field.closest('.lead-date-field');
        const label = field.closest('label');
        const standalone = dateContainer || label?.matches('.estimator-field, .drawer-field');
        if (standalone) {
          error.classList.add('is-standalone');
          (dateContainer || label).insertAdjacentElement('afterend', error);
        } else (label || field.parentElement).append(error);
        errors.set(field, error);
        field.setAttribute('aria-describedby', [field.getAttribute('aria-describedby'), error.id].filter(Boolean).join(' '));
      }
      error.querySelector('.avana-field-error-text').textContent = message;
      field.setAttribute('aria-invalid', 'true');
      field.setAttribute('aria-errormessage', error.id);
    };
    const validateField = (field) => {
      const message = messageFor(field);
      setError(field, message);
      return !message;
    };
    form.addEventListener('focusout', (event) => { if (eligible(event.target)) validateField(event.target); }, { signal });
    const recheck = (event) => {
      if (errors.has(event.target)) validateField(event.target);
      if (event.target.name === 'date_flexible') {
        const date = form.querySelector('[data-lead-date-display]');
        if (date && errors.has(date)) validateField(date);
      }
    };
    form.addEventListener('input', recheck, { signal });
    form.addEventListener('change', recheck, { signal });
    const reset = () => { [...errors.keys()].forEach(clearError); };
    form.addEventListener('reset', reset, { signal });
    return {
      validate(fields = Array.from(form.querySelectorAll('input, select, textarea')).filter(eligible)) {
        return fields.filter((field) => !validateField(field));
      },
      reset
    };
  };

    if (window.AvanaEventPageRuntime) {
      window.AvanaEventPageRuntime.initAll(document);
      return;
    }

    const instances = new WeakMap();
    const init = (eventPage) => {
    if (!eventPage || instances.has(eventPage)) return;
    const controller = new AbortController();
    const $ = (selector, root = eventPage) => root.querySelector(selector);
    const $$ = (selector, root = eventPage) => [...root.querySelectorAll(selector)];
    window.dataLayer = window.dataLayer || [];
    const track = (event, details = {}) => {
      if (event === 'av_form_submitted') {
        const parameters = { ...details, send_to: 'G-B3ZSTY6XLY' };
        if (typeof window.gtag === 'function') window.gtag('event', event, parameters);
        else {
          const queueGoogleEvent = function () { window.dataLayer.push(arguments); };
          queueGoogleEvent('event', event, parameters);
        }
      } else {
        window.dataLayer.push({ event, ...details });
      }
      document.dispatchEvent(new CustomEvent('avana:analytics', { detail: { event, ...details } }));
    };
    const configNode = $('[data-avana-event-config]');
    let eventConfig = {};
    try {
      eventConfig = configNode ? JSON.parse(configNode.textContent) : {};
    } catch (error) {
      console.error('Avana event-page configuration could not be parsed.', error);
    }
    const toast = $('.toast');
    let toastTimer;
    const showToast = (message) => {
      toast.textContent = message;
      toast.hidden = false;
      clearTimeout(toastTimer);
      toastTimer = setTimeout(() => { toast.hidden = true; }, 3200);
    };
    const syncBodyLock = () => {
      const dialogOpen = $$('dialog').some((dialog) => dialog.open);
      const leadOpen = $('.lead-column')?.classList.contains('open');
      document.body.classList.toggle('avana-event-modal-open', dialogOpen || leadOpen);
      document.body.classList.toggle('avana-event-lead-open', Boolean(leadOpen));
    };
    const params = new URLSearchParams(window.location.search);
    const applyCampaignFields = () => {
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid'].forEach((key) => {
        $$(`input[name="${key}"]`).forEach((input) => { input.value = params.get(key) || ''; });
      });
    };
    applyCampaignFields();
    $$('[data-track="phone_click"]').forEach((link) => {
      link.addEventListener('click', () => track('phone_click', { location: link.closest('footer') ? 'footer' : 'page' }));
    });
    const defaultGalleryItems = [
      { type: 'video', src: 'https://avanavenue.com/cdn/shop/videos/c/vp/cb899e3020334e8dbf90a57c5bce692d/cb899e3020334e8dbf90a57c5bce692d.HD-1080p-3.3Mbps-81860600.mp4?v=0', poster: 'https://avanavenue.com/cdn/shop/files/avana-venue53.webp?v=1766923948&width=1800', caption: 'A cinematic preview of celebrations at Avana Venue.' },
      { type: 'photo', src: 'https://cdn.shopify.com/s/files/1/0710/2038/0260/files/white-ballroom.webp?v=1778740300', caption: 'The ballroom, ready for an elegant wedding reception.' },
      { type: 'photo', src: 'https://avanavenue.com/cdn/shop/files/avana-venue135.webp?v=1766923948&width=1400', caption: 'A romantic reception design inside Avana Venue.' },
      { type: 'photo', src: 'https://avanavenue.com/cdn/shop/files/c6_19360d39-f0a7-40da-bfd5-e426da292358.webp?v=1766928080&width=1400', caption: 'A first dance framed by flowers, light, and atmosphere.' },
      { type: 'photo', src: 'https://avanavenue.com/cdn/shop/files/cont2.webp?v=1766927771&width=1400', caption: 'Candlelit tables and layered floral details.' },
      { type: 'photo', src: 'https://avanavenue.com/cdn/shop/files/avana_4d4ac5d6-1531-4f20-8e58-ec19a8c9c493.webp?v=1747689081&width=1400', caption: 'A champagne tower designed for a celebratory moment.' },
      { type: 'photo', src: 'https://avanavenue.com/cdn/shop/files/c8.webp?v=1766928333&width=1400', caption: 'Rich color, soft candlelight, and statement florals.' },
      { type: 'photo', src: 'https://avanavenue.com/cdn/shop/files/avana-venue142.webp?v=1766923949&width=1400', caption: 'A ballroom layout for a grand guest experience.' },
      { type: 'photo', src: 'https://avanavenue.com/cdn/shop/files/avana-venue197.webp?v=1766923948&width=1400', caption: 'Warm, intimate tablescape details.' },
      { type: 'photo', src: 'https://avanavenue.com/cdn/shop/files/avana-venue28.webp?v=1766914359&width=1400', caption: 'A bold reception palette with luxe floral styling.' },
      { type: 'photo', src: 'https://avanavenue.com/cdn/shop/files/avana-venue53.webp?v=1766923948&width=1800', caption: 'A newlywed moment in Avana’s dramatic interior.' }
    ];
    const galleryItems = Array.isArray(eventConfig.galleryItems) && eventConfig.galleryItems.length
      ? eventConfig.galleryItems.filter((item) => item?.src).map((item) => ({ ...item, type: item.type === 'image' ? 'photo' : item.type }))
      : defaultGalleryItems;
    const galleryDialog = $('#gallery-dialog');
    const galleryMedia = $('[data-gallery-media]');
    const galleryThumbs = $('[data-gallery-thumbs]');
    const galleryCount = $('[data-gallery-count]');
    const galleryCaption = $('[data-gallery-caption]');
    let galleryFilter = 'all';
    let galleryPosition = 0;
    const filteredGalleryItems = () => galleryItems.map((item, originalIndex) => ({ ...item, originalIndex })).filter((item) => galleryFilter === 'all' || item.type === galleryFilter);
    const renderGallery = () => {
      const items = filteredGalleryItems();
      if (!items.length) return;
      galleryPosition = (galleryPosition + items.length) % items.length;
      const item = items[galleryPosition];
      galleryMedia.replaceChildren();
      if (item.type === 'video') {
        const video = document.createElement('video');
        Object.assign(video, { src: item.src, poster: item.poster, controls: true, autoplay: true, loop: true, muted: true, playsInline: true });
        video.setAttribute('aria-label', item.caption);
        galleryMedia.append(video);
      } else {
        const image = document.createElement('img');
        image.src = item.src;
        image.alt = item.caption;
        galleryMedia.append(image);
      }
      galleryCount.textContent = `${galleryPosition + 1} / ${items.length}`;
      galleryCaption.textContent = item.caption;
      galleryThumbs.replaceChildren();
      items.forEach((thumbItem, position) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.classList.toggle('active', position === galleryPosition);
        button.setAttribute('aria-label', `View gallery item ${position + 1}`);
        if (thumbItem.type === 'video') button.innerHTML = '<span class="video-thumb" aria-hidden="true">▶</span>';
        else {
          const image = document.createElement('img');
          image.src = thumbItem.src;
          image.alt = '';
          image.loading = 'lazy';
          button.append(image);
        }
        button.addEventListener('click', () => { galleryPosition = position; renderGallery(); });
        galleryThumbs.append(button);
      });
    };
    const openGallery = (originalIndex = 0) => {
      galleryFilter = 'all';
      $$('[data-gallery-filter]').forEach((button) => {
        const active = button.dataset.galleryFilter === 'all';
        button.classList.toggle('active', active);
        button.setAttribute('aria-selected', String(active));
      });
      galleryPosition = Math.max(0, galleryItems.findIndex((_, index) => index === Number(originalIndex)));
      renderGallery();
      if (!galleryDialog.open) galleryDialog.showModal();
      syncBodyLock();
      track('gallery_open', { item_index: Number(originalIndex) + 1 });
    };
    $$('[data-gallery-index]').forEach((button) => button.addEventListener('click', () => openGallery(button.dataset.galleryIndex)));
    $$('[data-open-gallery]').forEach((button) => button.addEventListener('click', () => openGallery(0)));
    $('[data-close-gallery]').addEventListener('click', () => galleryDialog.close());
    $('[data-gallery-prev]').addEventListener('click', () => { galleryPosition -= 1; renderGallery(); });
    $('[data-gallery-next]').addEventListener('click', () => { galleryPosition += 1; renderGallery(); });
    $$('[data-gallery-filter]').forEach((button) => {
      button.addEventListener('click', () => {
        galleryFilter = button.dataset.galleryFilter;
        galleryPosition = 0;
        $$('[data-gallery-filter]').forEach((tab) => {
          const active = tab === button;
          tab.classList.toggle('active', active);
          tab.setAttribute('aria-selected', String(active));
        });
        renderGallery();
        track('gallery_filter', { media_type: galleryFilter });
      });
    });
    galleryDialog.addEventListener('close', syncBodyLock);
    document.addEventListener('keydown', (event) => {
      if (!galleryDialog.open) return;
      if (event.key === 'ArrowLeft') { galleryPosition -= 1; renderGallery(); }
      if (event.key === 'ArrowRight') { galleryPosition += 1; renderGallery(); }
    }, { signal: controller.signal });
    const reviewPhotoTrack = $('[data-review-photo-track]');
    const reviewPhotoPrev = $('[data-review-photos-prev]');
    const reviewPhotoNext = $('[data-review-photos-next]');
    const syncReviewPhotoArrows = () => {
      const maxScroll = Math.max(0, reviewPhotoTrack.scrollWidth - reviewPhotoTrack.clientWidth);
      reviewPhotoPrev.hidden = reviewPhotoTrack.scrollLeft <= 2;
      reviewPhotoNext.hidden = reviewPhotoTrack.scrollLeft >= maxScroll - 2;
    };
    const scrollReviewPhotos = (direction) => {
      const firstItem = $('button', reviewPhotoTrack);
      const itemWidth = firstItem ? firstItem.getBoundingClientRect().width : 110;
      reviewPhotoTrack.scrollBy({ left: direction * (itemWidth + 10) * 3, behavior: 'smooth' });
    };
    reviewPhotoPrev.addEventListener('click', () => scrollReviewPhotos(-1));
    reviewPhotoNext.addEventListener('click', () => scrollReviewPhotos(1));
    reviewPhotoTrack.addEventListener('scroll', () => requestAnimationFrame(syncReviewPhotoArrows), { passive: true });
    window.addEventListener('resize', syncReviewPhotoArrows, { signal: controller.signal });
    requestAnimationFrame(syncReviewPhotoArrows);
    const defaultBallroomProfiles = {
      white: {
        eyebrow: 'White Ballroom',
        title: 'The Grand White Ballroom',
        image: 'https://cdn.shopify.com/s/files/1/0710/2038/0260/files/white-ballroom.webp?v=1778740300',
        alt: 'The Grand White Ballroom at Avana Venue',
        copy: 'A breathtaking space designed for grand celebrations. Captivating aesthetics, renowned catering, custom lighting, and attentive service come together for a polished guest experience.',
        capacity: 'Up to 340',
        style: 'Grand & Elegant',
        best: 'Large Events',
        tags: ['Weddings', 'Quinceañeras', 'Birthday Parties', 'Corporate Events', 'Bar & Bat Mitzvahs'],
        cta: 'Check availability'
      },
      modern: {
        eyebrow: 'Modern Ballroom',
        title: 'The Modern Ballroom',
        image: 'https://cdn.shopify.com/s/files/1/0710/2038/0260/files/modern.webp?v=1778740301',
        alt: 'The Modern Ballroom at Avana Venue',
        copy: 'A sleek, stylish space that pairs contemporary design with timeless elegance. Its intimate scale, customizable lighting, and tailored service make every celebration feel personal.',
        capacity: 'Up to 150',
        style: 'Sleek & Intimate',
        best: 'Intimate Events',
        tags: ['Christenings', 'Bridal Showers', 'Anniversaries', 'Engagements', 'Baby Showers'],
        cta: 'Check availability'
      },
      sky: {
        eyebrow: 'Sky Lounge · Opening Soon',
        title: 'The Sky Lounge',
        image: 'https://cdn.shopify.com/s/files/1/0710/2038/0260/files/sky-lounge-avana-venue.webp?v=1778760437',
        alt: 'The open-air Sky Lounge at Avana Venue',
        copy: 'An extraordinary open-air experience with enchanting aesthetics, outdoor catering, and personalized service—where the freshness of the outdoors meets lasting sophistication.',
        capacity: 'Up to 180',
        style: 'Open-Air',
        best: 'Outdoor Events',
        tags: ['Weddings', 'Birthday Parties', 'Corporate Events', 'Cocktail Parties'],
        cta: 'Join the waitlist'
      }
    };
    const ballroomProfiles = eventConfig.ballrooms && Object.keys(eventConfig.ballrooms).length
      ? eventConfig.ballrooms
      : defaultBallroomProfiles;
    const ballroomDialog = $('#ballroom-dialog');
    const openBallroomProfile = (profileKey) => {
      const profile = ballroomProfiles[profileKey];
      if (!profile) return;
      const image = $('[data-ballroom-dialog-image]', ballroomDialog);
      image.src = profile.image;
      image.alt = profile.alt;
      $('[data-ballroom-dialog-eyebrow]', ballroomDialog).textContent = profile.eyebrow;
      $('[data-ballroom-dialog-title]', ballroomDialog).textContent = profile.title;
      $('[data-ballroom-dialog-copy]', ballroomDialog).textContent = profile.copy;
      $('[data-ballroom-dialog-capacity]', ballroomDialog).textContent = profile.capacity;
      $('[data-ballroom-dialog-style]', ballroomDialog).textContent = profile.style;
      $('[data-ballroom-dialog-best]', ballroomDialog).textContent = profile.best;
      const tagList = $('[data-ballroom-dialog-tags]', ballroomDialog);
      tagList.replaceChildren(...profile.tags.map((tag) => Object.assign(document.createElement('span'), { textContent: tag })));
      $('[data-ballroom-dialog-cta]', ballroomDialog).textContent = profile.cta;
      if (!ballroomDialog.open) ballroomDialog.showModal();
      syncBodyLock();
      track('ballroom_profile_open', { ballroom: profileKey });
    };
    $$('[data-ballroom-profile]').forEach((button) => button.addEventListener('click', () => openBallroomProfile(button.dataset.ballroomProfile)));
    $('[data-close-ballroom]').addEventListener('click', () => ballroomDialog.close());
    ballroomDialog.addEventListener('close', syncBodyLock);
    const leadColumn = $('.lead-column');
    const leadForm = $('#lead-form');
    const leadValidation = createFieldValidation(leadForm, { signal: controller.signal });
    const leadSuccess = $('#lead-success');
    const leadScrollBody = $('[data-lead-scroll]', leadColumn);
    const leadCloseButton = $('[data-close-lead]', leadColumn);
    const mobileLeadSheetQuery = window.matchMedia('(max-width: 720px)');
    let leadReturnFocus = null;
    let leadPreviousHtmlOverflow = '';
    let leadPreviousBodyOverflow = '';
    let mobileLeadScrollLocked = false;
    const lockMobileLeadScroll = () => {
      if (mobileLeadScrollLocked) return;
      leadPreviousHtmlOverflow = document.documentElement.style.overflow;
      leadPreviousBodyOverflow = document.body.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      mobileLeadScrollLocked = true;
    };
    const restoreMobileLeadScroll = () => {
      if (!mobileLeadScrollLocked) return;
      document.documentElement.style.overflow = leadPreviousHtmlOverflow;
      document.body.style.overflow = leadPreviousBodyOverflow;
      mobileLeadScrollLocked = false;
    };
    const openLead = (source = 'page_cta', trigger = document.activeElement) => {
      if (galleryDialog.open) galleryDialog.close();
      if (ballroomDialog.open) ballroomDialog.close();
      if ($('#estimator-dialog').open) $('#estimator-dialog').close();
      if (window.matchMedia('(max-width: 900px)').matches) {
        leadReturnFocus = trigger;
        leadColumn.classList.add('open');
        if (leadScrollBody) leadScrollBody.scrollTop = 0;
        if (mobileLeadSheetQuery.matches) {
          lockMobileLeadScroll();
          leadColumn.setAttribute('role', 'dialog');
          leadColumn.setAttribute('aria-modal', 'true');
          requestAnimationFrame(() => leadCloseButton?.focus());
        } else {
          setTimeout(() => leadColumn.querySelector('input:not([type=hidden])')?.focus(), 120);
        }
        syncBodyLock();
      } else {
        leadColumn.scrollIntoView({ behavior: 'smooth', block: 'center' });
        leadColumn.animate([{ boxShadow: '0 0 0 0 rgba(155,117,72,0)' }, { boxShadow: '0 0 0 5px rgba(155,117,72,.28)' }, { boxShadow: '0 0 0 0 rgba(155,117,72,0)' }], { duration: 900 });
        setTimeout(() => leadColumn.querySelector('input:not([type=hidden])')?.focus(), 120);
      }
      track('lead_form_open', { source });
    };
    const closeLead = (restoreFocus = true) => {
      closeDateCalendar(false);
      leadColumn.classList.remove('open', 'is-calendar-active');
      leadColumn.removeAttribute('role');
      leadColumn.removeAttribute('aria-modal');
      restoreMobileLeadScroll();
      syncBodyLock();
      if (restoreFocus && leadReturnFocus?.focus) leadReturnFocus.focus();
    };
    $$('[data-open-lead]').forEach((button) => button.addEventListener('click', () => openLead(button.textContent.trim().toLowerCase().replace(/\s+/g, '_'), button)));
    leadCloseButton.addEventListener('click', () => closeLead(true));

    const leadDateDisplay = $('[data-lead-date-display]', leadForm);
    const leadDateInput = $('[data-lead-date]', leadForm);
    const leadDateField = $('.lead-date-field', leadForm);
    const leadDateOpen = $('[data-lead-date-open]', leadForm);
    const leadCalendar = $('[data-lead-calendar]', leadForm);
    const leadCalendarClose = $('[data-lead-calendar-close]', leadForm);
    const leadCalendarMonth = $('[data-lead-calendar-month]', leadForm);
    const leadCalendarYear = $('[data-lead-calendar-year]', leadForm);
    const leadCalendarGrid = $('[data-lead-calendar-grid]', leadForm);
    const leadPhone = $('[data-lead-phone]', leadForm);
    const calendarToday = new Date();
    calendarToday.setHours(0, 0, 0, 0);
    let calendarViewDate = new Date(calendarToday.getFullYear(), calendarToday.getMonth(), 1);
    const localISODate = (value = new Date()) => `${value.getFullYear()}-${String(value.getMonth() + 1).padStart(2, '0')}-${String(value.getDate()).padStart(2, '0')}`;
    const parseISODate = (value) => {
      const parts = String(value || '').split('-').map(Number);
      if (parts.length !== 3 || !parts[0] || !parts[1] || !parts[2]) return null;
      const parsed = new Date(parts[0], parts[1] - 1, parts[2]);
      if (parsed.getFullYear() !== parts[0] || parsed.getMonth() !== parts[1] - 1 || parsed.getDate() !== parts[2]) return null;
      parsed.setHours(0, 0, 0, 0);
      return parsed;
    };
    const formatCalendarDate = (value) => `${value.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}.`;
    const populateCalendarYears = () => {
      leadCalendarYear.replaceChildren();
      for (let year = calendarToday.getFullYear(); year <= calendarToday.getFullYear() + 6; year += 1) {
        const option = document.createElement('option');
        option.value = String(year);
        option.textContent = String(year);
        leadCalendarYear.append(option);
      }
    };
    const renderDateCalendar = () => {
      const year = calendarViewDate.getFullYear();
      const month = calendarViewDate.getMonth();
      leadCalendarMonth.value = String(month);
      leadCalendarYear.value = String(year);
      leadCalendarGrid.replaceChildren();
      const firstWeekday = new Date(year, month, 1).getDay();
      const selectedISO = leadDateInput.value;
      for (let index = 0; index < 42; index += 1) {
        const cellDate = new Date(year, month, 1 - firstWeekday + index);
        cellDate.setHours(0, 0, 0, 0);
        const cellISO = localISODate(cellDate);
        const outsideMonth = cellDate.getMonth() !== month;
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'lead-calendar-day';
        button.textContent = String(cellDate.getDate());
        button.dataset.leadCalendarDate = cellISO;
        button.setAttribute('aria-label', formatCalendarDate(cellDate));
        button.setAttribute('aria-selected', String(cellISO === selectedISO));
        if (outsideMonth) button.classList.add('is-outside');
        if (cellISO === localISODate(calendarToday)) button.classList.add('is-today');
        if (cellISO === selectedISO) button.classList.add('is-selected');
        if (outsideMonth || cellDate.getTime() < calendarToday.getTime()) button.disabled = true;
        button.addEventListener('click', () => {
          const chosenDate = parseISODate(button.dataset.leadCalendarDate);
          if (!chosenDate) return;
          leadDateInput.value = localISODate(chosenDate);
          leadDateDisplay.value = formatCalendarDate(chosenDate);
          leadDateDisplay.dispatchEvent(new Event('input', { bubbles: true }));
          leadDateDisplay.dispatchEvent(new Event('change', { bubbles: true }));
          leadDateInput.dispatchEvent(new Event('change', { bubbles: true }));
          closeDateCalendar(true);
        });
        leadCalendarGrid.append(button);
      }
    };
    function openDateCalendar() {
      const selectedDate = parseISODate(leadDateInput.value);
      calendarViewDate = selectedDate ? new Date(selectedDate.getFullYear(), selectedDate.getMonth(), 1) : new Date(calendarToday.getFullYear(), calendarToday.getMonth(), 1);
      renderDateCalendar();
      leadCalendar.hidden = false;
      leadDateDisplay.setAttribute('aria-expanded', 'true');
      leadDateField.classList.add('is-calendar-open');
      if (mobileLeadSheetQuery.matches) leadColumn.classList.add('is-calendar-active');
      requestAnimationFrame(() => {
        if (mobileLeadSheetQuery.matches) {
          leadCalendarClose.focus();
          return;
        }
        const calendarBounds = leadCalendar.getBoundingClientRect();
        const scrollPanel = leadColumn.closest('.lead-sticky-shell') || leadColumn;
        const scrollBounds = scrollPanel.getBoundingClientRect();
        const overflow = calendarBounds.bottom - scrollBounds.bottom + 18;
        if (overflow > 0) scrollPanel.scrollBy({ top: overflow, behavior: 'smooth' });
      });
    }
    function closeDateCalendar(restoreFocus = false) {
      if (leadCalendar.hidden) return;
      leadCalendar.hidden = true;
      leadDateDisplay.setAttribute('aria-expanded', 'false');
      leadDateField.classList.remove('is-calendar-open');
      leadColumn.classList.remove('is-calendar-active');
      if (restoreFocus) leadDateDisplay.focus();
    }
    populateCalendarYears();
    leadDateDisplay.addEventListener('click', openDateCalendar);
    leadDateDisplay.addEventListener('beforeinput', (event) => event.preventDefault());
    leadDateDisplay.addEventListener('paste', (event) => event.preventDefault());
    leadDateDisplay.addEventListener('keydown', (event) => {
      if (['Enter', ' ', 'ArrowDown'].includes(event.key)) { event.preventDefault(); openDateCalendar(); }
      else if (event.key.length === 1) event.preventDefault();
    });
    leadDateOpen.addEventListener('click', openDateCalendar);
    leadCalendarClose.addEventListener('click', () => closeDateCalendar(true));
    leadCalendarMonth.addEventListener('change', () => { calendarViewDate = new Date(Number(leadCalendarYear.value), Number(leadCalendarMonth.value), 1); renderDateCalendar(); });
    leadCalendarYear.addEventListener('change', () => { calendarViewDate = new Date(Number(leadCalendarYear.value), Number(leadCalendarMonth.value), 1); renderDateCalendar(); });
    leadCalendar.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      event.preventDefault();
      event.stopPropagation();
      closeDateCalendar(true);
    });
    document.addEventListener('pointerdown', (event) => {
      if (!leadCalendar.hidden && !leadDateField.contains(event.target)) closeDateCalendar(false);
    }, { signal: controller.signal });
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || !leadColumn.classList.contains('open') || !leadCalendar.hidden) return;
      closeLead(true);
    }, { signal: controller.signal });
    const formatPhone = (value) => {
      let digits = String(value || '').replace(/\D/g, '');
      if (digits.length > 10 && digits.startsWith('1')) digits = digits.slice(1);
      digits = digits.slice(0, 10);
      if (digits.length <= 3) return digits ? `(${digits}` : '';
      if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
      return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
    };
    leadPhone.addEventListener('input', () => { leadPhone.value = formatPhone(leadPhone.value); });
    leadPhone.addEventListener('change', () => { leadPhone.value = formatPhone(leadPhone.value); });
    const leadPricingHelp = $('[data-lead-pricing-help]', leadForm);
    const leadPricingTrigger = $('[data-lead-pricing-tooltip-trigger]', leadForm);
    const leadPricingTooltip = $('[data-lead-pricing-tooltip]', leadForm);
    const leadPricingHoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
    const leadPricingMobileQuery = window.matchMedia('(max-width: 720px)');
    const leadPricingScrollPanel = leadColumn.closest('.lead-sticky-shell') || leadColumn;
    let leadPricingPointerFocus = false;
    const leadPricingIsOpen = () => leadPricingTrigger?.getAttribute('aria-expanded') === 'true';
    const positionLeadPricingTooltip = () => {
      if (!leadPricingIsOpen() || !leadPricingTooltip) return;
      if (leadPricingMobileQuery.matches) {
        leadPricingTooltip.dataset.placement = 'flow';
        return;
      }
      leadPricingTooltip.dataset.placement = 'below';
      const triggerBounds = leadPricingTrigger.getBoundingClientRect();
      const panelBounds = leadPricingScrollPanel.getBoundingClientRect();
      const viewportTop = Math.max(10, panelBounds.top);
      const viewportBottom = Math.min(window.innerHeight - 10, panelBounds.bottom);
      const tooltipHeight = leadPricingTooltip.offsetHeight;
      const spaceAbove = triggerBounds.top - viewportTop - 12;
      const spaceBelow = viewportBottom - triggerBounds.bottom - 12;
      if (spaceAbove >= tooltipHeight) leadPricingTooltip.dataset.placement = 'above';
      else if (spaceBelow >= tooltipHeight) leadPricingTooltip.dataset.placement = 'below';
      else leadPricingTooltip.dataset.placement = 'flow';
    };
    const setLeadPricingTooltip = (open) => {
      if (!leadPricingHelp || !leadPricingTrigger || !leadPricingTooltip) return;
      leadPricingTrigger.setAttribute('aria-expanded', String(open));
      leadPricingHelp.classList.toggle('is-open', open);
      leadPricingTooltip.hidden = !open;
      if (!open) {
        delete leadPricingTooltip.dataset.placement;
        return;
      }
      requestAnimationFrame(() => {
        positionLeadPricingTooltip();
        if (leadPricingTooltip.dataset.placement === 'flow' && leadPricingMobileQuery.matches) {
          leadPricingHelp.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        }
      });
    };
    if (leadPricingHelp && leadPricingTrigger && leadPricingTooltip) {
      leadPricingHelp.addEventListener('pointerenter', () => {
        if (leadPricingHoverQuery.matches) setLeadPricingTooltip(true);
      });
      leadPricingHelp.addEventListener('pointerleave', () => {
        if (leadPricingHoverQuery.matches && !leadPricingHelp.contains(document.activeElement)) setLeadPricingTooltip(false);
      });
      leadPricingTrigger.addEventListener('pointerdown', () => {
        leadPricingPointerFocus = true;
        requestAnimationFrame(() => { leadPricingPointerFocus = false; });
      });
      leadPricingHelp.addEventListener('focusin', () => {
        if (!leadPricingPointerFocus) setLeadPricingTooltip(true);
      });
      leadPricingHelp.addEventListener('focusout', () => {
        setTimeout(() => {
          if (!leadPricingHelp.contains(document.activeElement) && !leadPricingHelp.matches(':hover')) setLeadPricingTooltip(false);
        }, 0);
      });
      leadPricingTrigger.addEventListener('click', (event) => {
        event.preventDefault();
        if (leadPricingHoverQuery.matches) setLeadPricingTooltip(true);
        else setLeadPricingTooltip(!leadPricingIsOpen());
      });
      document.addEventListener('pointerdown', (event) => {
        if (leadPricingIsOpen() && !leadPricingHelp.contains(event.target)) setLeadPricingTooltip(false);
      }, { signal: controller.signal });
      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || !leadPricingIsOpen()) return;
        event.preventDefault();
        setLeadPricingTooltip(false);
        leadPricingTrigger.focus();
      }, { signal: controller.signal });
      window.addEventListener('resize', positionLeadPricingTooltip, { signal: controller.signal });
      leadPricingScrollPanel.addEventListener('scroll', positionLeadPricingTooltip, { passive: true, signal: controller.signal });
    }
    const postLead = async (endpoint, data) => {
      const response = await fetch(endpoint, {
        method: 'POST',
        body: data,
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) throw new Error(`Lead endpoint returned ${response.status}.`);
    };
    const deliverLead = async (data, deliveryForm, formName) => {
      const makeWebhookUrl = String(eventConfig.makeWebhookUrl || '').trim();
      const formspreeSetting = String(eventConfig.formspreeEndpoint || '').trim();
      const formspreeEndpoint = /^https?:\/\//i.test(formspreeSetting)
        ? formspreeSetting
        : formspreeSetting ? `https://formspree.io/f/${formspreeSetting.replace(/^\/+|\/+$/g, '')}` : '';
      if (!makeWebhookUrl || !formspreeEndpoint) throw new Error('Both Make and Formspree destinations must be configured.');
      const destinations = [
        { name: 'make', endpoint: makeWebhookUrl, flag: 'makeDelivered' },
        { name: 'formspree', endpoint: formspreeEndpoint, flag: 'formspreeDelivered' }
      ].filter((destination) => deliveryForm.dataset[destination.flag] !== 'true');
      const results = await Promise.allSettled(destinations.map(async (destination) => {
        await postLead(destination.endpoint, data);
        deliveryForm.dataset[destination.flag] = 'true';
        track('lead_form_destination_success', { destination: destination.name, form_name: formName });
        return destination.name;
      }));
      const failedDestinations = results
        .map((result, index) => result.status === 'rejected' ? destinations[index].name : '')
        .filter(Boolean);
      if (failedDestinations.length) throw new Error(`Lead delivery failed for: ${failedDestinations.join(', ')}.`);
      if (deliveryForm.dataset.makeDelivered !== 'true' || deliveryForm.dataset.formspreeDelivered !== 'true') {
        throw new Error('Both lead destinations did not confirm delivery.');
      }
    };
    leadForm.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (leadForm.dataset.submitting === 'true') return;
      const invalid = leadValidation.validate();
      const error = $('.form-error', leadForm);
      if (invalid.length) {
        error.textContent = 'Please correct the highlighted fields.';
        error.dataset.validationSummary = 'true';
        error.hidden = false;
        invalid[0].focus();
        track('lead_form_error', { field: invalid[0].name });
        return;
      }
      error.hidden = true;
      const data = new FormData(leadForm);
      data.set('date_flexible', $('[name="date_flexible"]', leadForm).checked ? 'Yes' : 'No');
      data.set('source_url', window.location.href);
      data.set('page_title', document.title);
      data.set('submitted_at', new Date().toISOString());
      const submissionId = leadForm.dataset.submissionId || window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      leadForm.dataset.submissionId = submissionId;
      data.set('submission_id', submissionId);
      const formName = eventConfig.leadFormName || 'wedding_quote';
      const submitButton = $('.lead-submit', leadForm);
      const submitButtonLabel = submitButton.textContent;
      leadForm.dataset.submitting = 'true';
      submitButton.disabled = true;
      submitButton.textContent = 'Sending…';
      try {
        if (leadForm.dataset.trackedSubmissionId !== submissionId) {
          leadForm.dataset.trackedSubmissionId = submissionId;
          track('av_form_submitted', { form_name: formName, form_type: 'quote', event_profile: eventConfig.profileHandle || 'static-wedding', submission_id: submissionId, guest_range: data.get('guest_count'), flexible_date: data.get('date_flexible') === 'Yes', utm_source: data.get('utm_source') || 'direct' });
        }
        await deliverLead(data, leadForm, formName);
        leadForm.hidden = true;
        leadSuccess.hidden = false;
        if (leadScrollBody) leadScrollBody.scrollTop = 0;
      } catch (submissionError) {
        console.error('Avana quote request could not be delivered.', submissionError);
        error.textContent = 'We could not send your request. Please try again or call (818) 485-4444.';
        error.hidden = false;
        track('lead_form_delivery_error', { form_name: formName });
      } finally {
        delete leadForm.dataset.submitting;
        submitButton.disabled = false;
        submitButton.textContent = submitButtonLabel;
      }
    });
    $('[data-reset-lead]').addEventListener('click', () => {
      leadForm.reset();
      applyCampaignFields();
      leadForm.hidden = false;
      leadSuccess.hidden = true;
      delete leadForm.dataset.submissionId;
      delete leadForm.dataset.trackedSubmissionId;
      delete leadForm.dataset.makeDelivered;
      delete leadForm.dataset.formspreeDelivered;
      $$('[aria-invalid]', leadForm).forEach((field) => field.removeAttribute('aria-invalid'));
    });
    const estimatorDialog = $('#estimator-dialog');
    const estimatorForm = $('#estimator-form');
    const estimatorValidation = createFieldValidation(estimatorForm, { signal: controller.signal, requiredNames: ['estimator_guests', 'estimator_date'] });
    const estimateDrawer = $('#estimate-drawer');
    const estimateDrawerForm = $('#estimate-drawer-form');
    const drawerValidation = createFieldValidation(estimateDrawerForm, { signal: controller.signal, requiredNames: ['drawer_guests', 'drawer_date'] });
    const nextButton = $('[data-estimator-next]', estimatorDialog);
    const unlockButton = $('[data-estimator-unlock]', estimatorDialog);
    const estimatorError = $('[data-estimator-error]', estimatorForm);
    const backButton = $('[data-estimator-back]', estimatorDialog);
    const progress = $('[data-estimator-progress]', estimatorDialog);
    const guestInput = $('[name="estimator_guests"]', estimatorForm);
    const dateInput = $('[name="estimator_date"]', estimatorForm);
    const estimatorPhoneInput = $('[name="estimate_phone"]', estimatorForm);
    const drawerDateInput = $('[name="drawer_date"]', estimateDrawerForm);
    const today = new Date();
    const minimumEstimatorDate = [
      today.getFullYear(),
      String(today.getMonth() + 1).padStart(2, '0'),
      String(today.getDate()).padStart(2, '0')
    ].join('-');
    const minimumEstimatorMonth = minimumEstimatorDate.slice(0, 7);
    const setEstimatorDateMinimum = (mode = 'date') => {
      dateInput.min = mode === 'month' ? minimumEstimatorMonth : minimumEstimatorDate;
      if (drawerDateInput) drawerDateInput.min = minimumEstimatorDate;
    };
    setEstimatorDateMinimum();
    const defaultServiceRates = {
      ceremony: { label: 'Ceremony', amount: 3500, note: 'Starting price', icon: '♙' },
      reception: { label: 'Reception', amount: 5300, note: 'Local average', icon: '♜' },
      catering: { label: 'Catering', perGuest: 137, note: 'Local average', icon: '♨' },
      bar: { label: 'Bar service', perGuest: 50, note: 'Starting price', icon: '♧' }
    };
    const configuredRates = Array.isArray(eventConfig.estimatorOptions)
      ? eventConfig.estimatorOptions.filter((option) => option?.key && option.enabled !== false)
      : [];
    const serviceRates = configuredRates.length
      ? Object.fromEntries(configuredRates.map((option) => [option.key, {
        key: option.key,
        label: option.label,
        priceType: option.priceType,
        amount: Number(option.minimum || 0),
        maximum: Number(option.maximum || option.minimum || 0),
        perGuest: option.priceType === 'per-guest' ? Number(option.perGuest || 0) : 0,
        perGuestMinimum: option.priceType === 'per-guest' ? Number(option.minimum || option.perGuest || 0) : 0,
        perGuestMaximum: option.priceType === 'per-guest' ? Number(option.maximum || option.minimum || option.perGuest || 0) : 0,
        base: option.base === true,
        note: option.note || 'Illustrative estimate',
        icon: option.icon || '•'
      }]))
      : defaultServiceRates;
    const baseServiceRate = Object.values(serviceRates).find((item) => item.base === true) || null;
    const hasBaseRate = Boolean(baseServiceRate && (
      baseServiceRate.amount > 0 ||
      baseServiceRate.maximum > 0 ||
      baseServiceRate.perGuest > 0 ||
      baseServiceRate.perGuestMinimum > 0 ||
      baseServiceRate.perGuestMaximum > 0
    ));
    let estimatorStep = 1;
    let savedEstimate = null;
    const money = (value) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(value);
    const formatEstimateDate = (value, mode = 'date') => {
      if (!value) return 'Date not selected';
      if (mode === 'month') {
        const [year, month] = value.split('-').map(Number);
        return new Intl.DateTimeFormat('en-US', { month: 'short', year: 'numeric' }).format(new Date(year, month - 1, 1));
      }
      const [year, month, day] = value.split('-').map(Number);
      return new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', year: 'numeric' }).format(new Date(year, month - 1, day));
    };
    const calculateEstimate = ({ services, guests, date, dateMode = 'date' }) => {
      const estimateKeys = [...new Set([
        ...(hasBaseRate ? [baseServiceRate.key] : []),
        ...services
      ])];
      const lineItems = estimateKeys.map((key) => {
        const item = serviceRates[key];
        if (!item) return null;
        if (item.priceType === 'per-guest' || item.perGuest) {
          const firstRate = Number(item.perGuestMinimum || item.perGuest || 0);
          const secondRate = Number(item.perGuestMaximum || firstRate);
          const minimumPerGuest = Math.min(firstRate, secondRate);
          const maximumPerGuest = Math.max(firstRate, secondRate);
          const minimumAmount = minimumPerGuest * guests;
          const maximumAmount = maximumPerGuest * guests;
          return { key, ...item, amount: minimumAmount, minimumAmount, maximumAmount, minimumPerGuest, maximumPerGuest };
        }
        const firstAmount = Number(item.amount || 0);
        const secondAmount = Number(item.maximum || firstAmount);
        const minimumAmount = Math.min(firstAmount, secondAmount);
        const maximumAmount = Math.max(firstAmount, secondAmount);
        return { key, ...item, amount: minimumAmount, minimumAmount, maximumAmount };
      }).filter(Boolean);
      const rawMinimum = lineItems.reduce((sum, item) => sum + item.minimumAmount, 0);
      const rawMaximum = lineItems.reduce((sum, item) => sum + item.maximumAmount, 0);
      const seasonFactor = 1;
      const lowBase = rawMinimum * seasonFactor;
      const highBase = rawMaximum * seasonFactor;
      const low = Math.round(Math.min(lowBase, highBase));
      const high = Math.round(Math.max(lowBase, highBase));
      return { services, guests, date, dateMode, lineItems, seasonFactor, low, high, baseIncluded: hasBaseRate };
    };
    const currentModalData = () => {
      const services = $$('[name="services"]:checked', estimatorForm).map((input) => input.value);
      const dateMode = $('[name="date_mode"]:checked', estimatorForm).value;
      return calculateEstimate({ services, guests: Number(guestInput.value), date: dateInput.value, dateMode });
    };
    const isStepValid = () => {
      if (estimatorStep === 1) return hasBaseRate || $$('[name="services"]:checked', estimatorForm).length > 0;
      if (estimatorStep === 2) return Number(guestInput.value) >= 1 && Number(guestInput.value) <= 340;
      if (estimatorStep === 3) return Boolean(dateInput.value) && dateInput.checkValidity();
      return true;
    };
    const updateEstimatorStep = () => {
      $$('.estimator-step', estimatorForm).forEach((section) => section.classList.toggle('active', Number(section.dataset.step) === estimatorStep));
      progress.style.width = `${estimatorStep * 25}%`;
      backButton.hidden = estimatorStep === 1;
      nextButton.hidden = estimatorStep === 4;
      unlockButton.hidden = estimatorStep !== 4;
      nextButton.disabled = !isStepValid();
      if (estimatorStep === 4) {
        unlockButton.disabled = estimatorForm.dataset.submitting === 'true';
      }
    };
    const populateEstimateDrawer = (estimate) => {
      $$('[name="drawer_services"]', estimateDrawerForm).forEach((input) => { input.checked = estimate.services.includes(input.value); });
      $('[name="drawer_guests"]', estimateDrawerForm).value = estimate.guests;
      $('[name="drawer_date"]', estimateDrawerForm).value = estimate.dateMode === 'month' ? `${estimate.date}-01` : estimate.date;
      $('[data-drawer-estimate-range]').textContent = `${money(estimate.low)} - ${money(estimate.high)}`;
    };
    const renderEstimate = (estimate) => {
      savedEstimate = estimate;
      $('[data-estimate-initial]').hidden = true;
      $('[data-estimate-complete]').hidden = false;
      $('[data-estimate-disclaimer]').hidden = false;
      $('[data-price-breakdown]').hidden = false;
      $('[data-saved-estimate-range]').textContent = `${money(estimate.low)} - ${money(estimate.high)}`;
      const selectedCountLabel = estimate.baseIncluded
        ? `${estimate.services.length} optional ${estimate.services.length === 1 ? 'extra' : 'extras'}`
        : `${estimate.services.length} ${estimate.services.length === 1 ? 'service' : 'services'}`;
      $('[data-saved-estimate-details]').textContent = `Details: ${formatEstimateDate(estimate.date, estimate.dateMode)}, ${estimate.guests} guests, ${selectedCountLabel}`;
      const breakdown = $('[data-price-breakdown-rows]');
      breakdown.replaceChildren();
      estimate.lineItems.forEach((item) => {
        const row = document.createElement('div');
        const lineItemPrice = item.minimumPerGuest !== undefined
          ? (item.minimumPerGuest === item.maximumPerGuest
            ? `${money(item.minimumPerGuest)} / guest`
            : `${money(item.minimumPerGuest)}–${money(item.maximumPerGuest)} / guest`)
          : (item.minimumAmount === item.maximumAmount
            ? money(item.minimumAmount)
            : `${money(item.minimumAmount)}–${money(item.maximumAmount)}`);
        row.innerHTML = `<span><i aria-hidden="true">${item.icon}</i>${item.label}</span><strong>${lineItemPrice}<small>${item.note}</small></strong>`;
        breakdown.append(row);
      });
      populateEstimateDrawer(estimate);
      track('price_estimate_complete', { services: estimate.services.join(','), guests: estimate.guests, event_date: estimate.date, event_profile: eventConfig.profileHandle || 'static-wedding', estimate_low: estimate.low, estimate_high: estimate.high });
    };
    const openEstimator = () => {
      if (estimatorForm.dataset.submitting === 'true') return;
      estimatorForm.reset();
      delete estimatorForm.dataset.submissionId;
      delete estimatorForm.dataset.trackedSubmissionId;
      delete estimatorForm.dataset.makeDelivered;
      delete estimatorForm.dataset.formspreeDelivered;
      if (estimatorError) estimatorError.hidden = true;
      estimatorStep = 1;
      dateInput.type = 'date';
      setEstimatorDateMinimum();
      updateEstimatorStep();
      estimatorDialog.showModal();
      syncBodyLock();
      track('price_estimator_open');
    };
    $$('[data-open-estimator]').forEach((button) => button.addEventListener('click', openEstimator));
    $('[data-close-estimator]').addEventListener('click', () => estimatorDialog.close());
    estimatorDialog.addEventListener('close', syncBodyLock);
    $$('[name="services"]', estimatorForm).forEach((input) => input.addEventListener('change', updateEstimatorStep));
    guestInput.addEventListener('input', updateEstimatorStep);
    dateInput.addEventListener('change', updateEstimatorStep);
    const formatEstimatorPhone = (value) => formatPhone(value).replace(') ', ')');
    estimatorPhoneInput.addEventListener('input', () => { estimatorPhoneInput.value = formatEstimatorPhone(estimatorPhoneInput.value); });
    estimatorPhoneInput.addEventListener('change', () => { estimatorPhoneInput.value = formatEstimatorPhone(estimatorPhoneInput.value); });
    $$('[name="date_mode"]', estimatorForm).forEach((input) => input.addEventListener('change', () => {
      dateInput.value = '';
      const dateMode = input.value === 'month' && input.checked ? 'month' : 'date';
      dateInput.type = dateMode;
      setEstimatorDateMinimum(dateMode);
      dateInput.setAttribute('aria-label', dateMode === 'month' ? (eventConfig.dateMonthLabel || 'Wedding month and year') : (eventConfig.dateLabel || 'Wedding date'));
      updateEstimatorStep();
    }));
    $$('input[required]', estimatorForm).forEach((input) => input.addEventListener('input', () => {
      if (estimatorError) estimatorError.hidden = true;
      updateEstimatorStep();
    }));
    nextButton.addEventListener('click', () => { if (estimatorStep < 4 && isStepValid()) estimatorStep += 1; updateEstimatorStep(); });
    backButton.addEventListener('click', () => { if (estimatorStep > 1) estimatorStep -= 1; updateEstimatorStep(); });
    unlockButton.addEventListener('click', async () => {
      if (estimatorForm.dataset.submitting === 'true') return;
      const invalid = estimatorValidation.validate();
      if (invalid.length) {
        estimatorStep = Number(invalid[0].closest('.estimator-step')?.dataset.step || 4);
        updateEstimatorStep();
        invalid[0].focus();
        return;
      }
      const estimate = currentModalData();
      const firstName = $('[name="estimate_first_name"]', estimatorForm).value;
      const lastName = $('[name="estimate_last_name"]', estimatorForm).value;
      const phone = formatPhone($('[name="estimate_phone"]', estimatorForm).value);
      const email = $('[name="estimate_email"]', estimatorForm).value;
      const services = estimate.lineItems.map((item) => item.label).join(', ');
      const preferredDate = formatEstimateDate(estimate.date, estimate.dateMode);
      const flexibleDate = estimate.dateMode === 'month' ? 'Yes' : 'No';
      const dateSelection = estimate.dateMode === 'month' ? 'Flexible month/year' : 'Exact date';
      const eventDate = estimate.dateMode === 'month' ? `${estimate.date}-01` : estimate.date;
      const estimatedRange = `${money(estimate.low)} - ${money(estimate.high)}`;
      const formName = `${eventConfig.leadFormName || 'wedding_quote'}_estimator`;
      const data = new FormData();
      data.set('first_name', firstName);
      data.set('last_name', lastName);
      data.set('phone', phone);
      data.set('email', email);
      data.set('event_date', eventDate);
      data.set('date_flexible', flexibleDate);
      data.set('guest_count', String(estimate.guests));
      data.set('event_profile', eventConfig.eventSingular || eventConfig.profileHandle || 'wedding');
      data.set('message', `Lead source: Price Estimator | Selected services: ${services} | Guests: ${estimate.guests} | Date selection: ${dateSelection} | Preferred date: ${preferredDate} | Estimated range: ${estimatedRange}`);
      data.set('submission_type', 'estimator');
      data.set('estimate_services', services);
      data.set('estimate_low', String(estimate.low));
      data.set('estimate_high', String(estimate.high));
      data.set('estimate_date_mode', estimate.dateMode);
      data.set('source_url', window.location.href);
      data.set('page_title', document.title);
      data.set('submitted_at', new Date().toISOString());
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid'].forEach((key) => {
        data.set(key, params.get(key) || '');
      });
      const submissionId = estimatorForm.dataset.submissionId || window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      estimatorForm.dataset.submissionId = submissionId;
      data.set('submission_id', submissionId);
      const unlockButtonLabel = unlockButton.textContent;
      estimatorForm.dataset.submitting = 'true';
      unlockButton.disabled = true;
      unlockButton.textContent = 'Sending…';
      if (estimatorError) estimatorError.hidden = true;
      try {
        if (estimatorForm.dataset.trackedSubmissionId !== submissionId) {
          estimatorForm.dataset.trackedSubmissionId = submissionId;
          track('av_form_submitted', { form_name: formName, form_type: 'estimator', event_profile: eventConfig.profileHandle || 'static-wedding', submission_id: submissionId, services: estimate.services.join(','), guests: estimate.guests, event_date: eventDate, flexible_date: flexibleDate === 'Yes', estimate_low: estimate.low, estimate_high: estimate.high });
        }
        await deliverLead(data, estimatorForm, formName);
        renderEstimate(estimate);
        estimatorDialog.close();
        showToast('Your estimate is ready and Avana Venue received your details.');
      } catch (submissionError) {
        console.error('Avana estimator lead could not be delivered.', submissionError);
        if (estimatorError) {
          estimatorError.textContent = 'We could not send your estimate. Please try again or call (818) 485-4444.';
          estimatorError.hidden = false;
        }
        track('price_estimator_lead_error', { form_name: formName });
      } finally {
        delete estimatorForm.dataset.submitting;
        unlockButton.textContent = unlockButtonLabel;
        updateEstimatorStep();
      }
    });
    const drawerEstimate = () => {
      const services = $$('[name="drawer_services"]:checked', estimateDrawerForm).map((input) => input.value);
      const guests = Number($('[name="drawer_guests"]', estimateDrawerForm).value);
      const date = drawerDateInput.value;
      return (hasBaseRate || services.length) && guests > 0 && date && drawerDateInput.checkValidity() ? calculateEstimate({ services, guests, date, dateMode: 'date' }) : null;
    };
    const updateDrawerPreview = () => {
      const estimate = drawerEstimate();
      if (estimate) $('[data-drawer-estimate-range]').textContent = `${money(estimate.low)} - ${money(estimate.high)}`;
      $('.estimate-drawer-footer button', estimateDrawerForm).disabled = !estimate;
    };
    $('[data-edit-estimate]').addEventListener('click', () => {
      if (!savedEstimate) return;
      populateEstimateDrawer(savedEstimate);
      estimateDrawer.showModal();
      syncBodyLock();
      track('price_estimate_edit_open');
    });
    $('[data-close-estimate-drawer]').addEventListener('click', () => estimateDrawer.close());
    estimateDrawer.addEventListener('close', syncBodyLock);
    $$('input', estimateDrawerForm).forEach((input) => input.addEventListener('input', updateDrawerPreview));
    $$('input[type="checkbox"]', estimateDrawerForm).forEach((input) => input.addEventListener('change', updateDrawerPreview));
    estimateDrawerForm.addEventListener('submit', (event) => {
      event.preventDefault();
      const invalid = drawerValidation.validate();
      if (invalid.length) { invalid[0].focus(); return; }
      const estimate = drawerEstimate();
      if (!estimate) return;
      renderEstimate(estimate);
      estimateDrawer.close();
      showToast('Your estimate has been updated.');
    });
    $$('[data-toggle]').forEach((button) => {
      button.addEventListener('click', () => {
        const target = $(button.dataset.toggle);
        const expanded = button.getAttribute('aria-expanded') === 'true';
        target.hidden = expanded;
        button.setAttribute('aria-expanded', String(!expanded));
        button.textContent = expanded ? 'Read more' : 'Read less';
      });
    });
    $$('[data-save]').forEach((button) => {
      button.addEventListener('click', () => {
        const saved = button.dataset.saved !== 'true';
        $$('[data-save]').forEach((other) => {
          other.dataset.saved = String(saved);
          other.textContent = saved ? '♥' : '♡';
          other.setAttribute('aria-label', saved ? 'Remove saved venue' : 'Save this venue');
        });
        showToast(saved ? 'Avana Venue saved to your favorites.' : 'Removed from your favorites.');
        track(saved ? 'venue_save' : 'venue_unsave');
      });
    });
    $$('[data-share]').forEach((button) => {
      button.addEventListener('click', async () => {
        const shareData = { title: eventConfig.shareTitle || 'Avana Venue Weddings', text: eventConfig.shareText || 'Explore Avana Venue in North Hollywood.', url: window.location.href };
        try {
          if (navigator.share) await navigator.share(shareData);
          else if (navigator.clipboard) { await navigator.clipboard.writeText(window.location.href); showToast('Page link copied.'); }
          else showToast('Copy the page URL from your browser to share.');
          track('venue_share');
        } catch (error) { if (error.name !== 'AbortError') showToast('Sharing is not available in this preview.'); }
      });
    });
    const reviewSearch = $('[data-review-search]');
    const reviewData = JSON.parse($('#avana-review-data').textContent);
    const reviewList = $('[data-review-list]');
    const reviewStatus = $('[data-review-status]');
    const reviewMore = $('[data-review-more]');
    const reviewPageSize = 6;
    let activeReviewSource = 'google';
    let visibleReviewCount = reviewPageSize;
    const reviewSources = {
      google: {
        name: 'Google',
        url: 'https://share.google/EqUYFikZMcGrBlzUA',
        icon: 'https://cdn.shopify.com/s/files/1/0710/2038/0260/files/google-reviews.webp'
      },
      yelp: {
        name: 'Yelp',
        url: 'https://www.yelp.com/biz/avana-venue-north-hollywood?uid=xAxRTwjtqmEef91YkTFTjw&utm_campaign=www_business_share_popup&utm_medium=copy_link&utm_source=(direct)',
        icon: 'https://cdn.shopify.com/s/files/1/0710/2038/0260/files/yelp.webp?v=1791542394'
      }
    };
    const reviewSourceName = (source) => (reviewSources[source] || reviewSources.google).name;
    const escapeReviewHtml = (value) => String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
    const renderReviews = () => {
      const term = reviewSearch.value.trim().toLowerCase();
      const sourceReviews = reviewData[activeReviewSource] || [];
      const matchingReviews = term
        ? sourceReviews.filter((review) => `${review.name} ${review.meta} ${review.text}`.toLowerCase().includes(term))
        : sourceReviews;
      const visibleReviews = term ? matchingReviews : matchingReviews.slice(0, visibleReviewCount);
      const sourceDetails = reviewSources[activeReviewSource] || reviewSources.google;
      const sourceName = sourceDetails.name;
      reviewList.replaceChildren();
      visibleReviews.forEach((review, index) => {
        const card = document.createElement('article');
        const avatarTone = ['',' alt',' gold',' blue'][index % 4];
        const initial = review.name.trim().charAt(0).toUpperCase();
        card.className = 'review-card';
        card.dataset.source = activeReviewSource;
        card.dataset.reviewText = `${review.name} ${review.meta} ${review.text}`.toLowerCase();
        card.innerHTML = `<header><div class="review-author"><div class="review-avatar${avatarTone}">${escapeReviewHtml(initial)}</div><div><strong>${escapeReviewHtml(review.name)}</strong><div class="review-score-line"><span aria-label="5 out of 5 stars">★★★★★</span><b>5.0</b></div></div></div><time>${escapeReviewHtml(review.date)}</time></header><p class="review-copy">${escapeReviewHtml(review.text)}</p><button class="review-read-more" type="button" data-review-toggle aria-expanded="false" hidden>Read more</button><a class="review-source-note" href="${escapeReviewHtml(sourceDetails.url)}" target="_blank" rel="noopener noreferrer" aria-label="View ${sourceName} reviews in a new window" title="${escapeReviewHtml(review.meta)}"><span class="review-source-label"><img src="${escapeReviewHtml(sourceDetails.icon)}" alt="" width="18" height="18" aria-hidden="true">Posted on ${sourceName}</span><span class="review-source-view">View<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M14 4h6v6M20 4l-9 9M19 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h5"></path></svg></span></a>`;
        reviewList.append(card);
        requestAnimationFrame(() => {
          const copy = $('.review-copy', card);
          const toggle = $('[data-review-toggle]', card);
          toggle.hidden = copy.scrollHeight <= copy.clientHeight + 2;
        });
      });
      const shownCount = visibleReviews.length;
      reviewStatus.textContent = `Showing ${shownCount} of ${matchingReviews.length} ${sourceName} reviews.`;
      reviewMore.hidden = Boolean(term) || shownCount >= matchingReviews.length;
      reviewMore.textContent = `Load ${Math.min(reviewPageSize, matchingReviews.length - shownCount)} more ${sourceName} reviews`;
    };
    reviewSearch.addEventListener('input', renderReviews);
    $$('[data-review-source]').forEach((button) => {
      button.addEventListener('click', () => {
        activeReviewSource = button.dataset.reviewSource;
        visibleReviewCount = reviewPageSize;
        $$('[data-review-source]').forEach((source) => {
          const selected = source === button;
          source.classList.toggle('active', selected);
          source.setAttribute('aria-selected', String(selected));
        });
        renderReviews();
      });
    });
    $$('[data-review-shortcut]').forEach((button) => {
      button.addEventListener('click', () => {
        const source = button.dataset.reviewShortcut;
        $(`[data-review-source="${source}"]`).click();
        history.replaceState(null, '', '#reviews');
        $('#reviews').scrollIntoView({ behavior: 'smooth', block: 'start' });
        track('review_shortcut_click', { source });
      });
    });
    reviewMore.addEventListener('click', () => {
      visibleReviewCount += reviewPageSize;
      renderReviews();
    });
    reviewList.addEventListener('click', (event) => {
      const toggle = event.target.closest('[data-review-toggle]');
      if (!toggle) return;
      const card = toggle.closest('.review-card');
      const expanded = card.classList.toggle('expanded');
      toggle.textContent = expanded ? 'Show less' : 'Read more';
      toggle.setAttribute('aria-expanded', String(expanded));
    });
    renderReviews();
    const observedSections = $$('section[id]');
    const anchorScroll = $('.anchor-scroll');
    const navLinks = $$('[data-scroll-link]');
    let activeNavLink = null;
    const activateNavLink = (activeLink) => {
      if (activeNavLink === activeLink) return;
      navLinks.forEach((link) => link.classList.toggle('active', link === activeLink));
      activeNavLink = activeLink;
      if (activeLink && anchorScroll && window.matchMedia('(max-width: 640px)').matches) {
        const scrollerRect = anchorScroll.getBoundingClientRect();
        const linkRect = activeLink.getBoundingClientRect();
        const centeredLeft = anchorScroll.scrollLeft + linkRect.left - scrollerRect.left - ((scrollerRect.width - linkRect.width) / 2);
        const maxLeft = Math.max(0, anchorScroll.scrollWidth - anchorScroll.clientWidth);
        anchorScroll.scrollTo({ left: Math.max(0, Math.min(maxLeft, centeredLeft)), behavior: 'smooth' });
      }
    };
    navLinks.forEach((link) => link.addEventListener('click', () => activateNavLink(link)));
    const pricingDetailsLink = $('.fact-detail-link[href="#pricing"]');
    pricingDetailsLink.addEventListener('click', (event) => {
      event.preventDefault();
      const pricingSection = $('#pricing');
      history.replaceState(null, '', '#pricing');
      pricingSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      activateNavLink(navLinks.find((link) => link.getAttribute('href') === '#pricing'));
      track('pricing_details_click');
    });
    const navTargets = navLinks.map((link) => ({ link, target: $(link.getAttribute('href')) })).filter((item) => item.target);
    let navScrollFrame = 0;
    const updateActiveNavFromScroll = () => {
      const stickyOffset = window.matchMedia('(max-width: 640px)').matches ? 260 : 228;
      const marker = window.scrollY + stickyOffset;
      let activeItem = navTargets[0];
      navTargets.forEach((item) => {
        if (!item.target.getClientRects().length) return;
        const pageTop = item.target.getBoundingClientRect().top + window.scrollY;
        if (pageTop <= marker) activeItem = item;
      });
      if (activeItem) activateNavLink(activeItem.link);
      navScrollFrame = 0;
    };
    window.addEventListener('scroll', () => {
      if (navScrollFrame) return;
      navScrollFrame = requestAnimationFrame(updateActiveNavFromScroll);
    }, { passive: true, signal: controller.signal });
    updateActiveNavFromScroll();
    window.addEventListener('resize', () => {
      if (!window.matchMedia('(max-width: 900px)').matches) {
        closeLead(false);
      } else if (!mobileLeadSheetQuery.matches) {
        restoreMobileLeadScroll();
        leadColumn.removeAttribute('role');
        leadColumn.removeAttribute('aria-modal');
      }
    }, { signal: controller.signal });

    eventPage.dataset.avanaInitialized = 'true';
    instances.set(eventPage, {
      destroy() {
        controller.abort();
        clearTimeout(toastTimer);
        restoreMobileLeadScroll();
        document.body.classList.remove('avana-event-modal-open', 'avana-event-lead-open');
        delete eventPage.dataset.avanaInitialized;
        instances.delete(eventPage);
      }
    });
    };

    const initAll = (scope = document) => {
      if (scope.matches?.('[data-av-event-page]')) init(scope);
      scope.querySelectorAll?.('[data-av-event-page]').forEach(init);
    };

    const destroyWithin = (scope) => {
      const roots = [];
      if (scope.matches?.('[data-av-event-page]')) roots.push(scope);
      scope.querySelectorAll?.('[data-av-event-page]').forEach((root) => roots.push(root));
      roots.forEach((root) => instances.get(root)?.destroy());
    };

    window.AvanaEventPageRuntime = { initAll, destroyWithin };
    initAll(document);
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => destroyWithin(event.target));
  })();
